//# sourceMappingURL=question.mjs.map
/// <reference types="./question.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $uuid from "../../../tiamat/crypto/uuid.mjs";
import * as $assoc from "../../../tiamat/gleam/assoc.mjs";
import * as $json_ from "../../../tiamat/gleam/json_.mjs";
import * as $levenshtein from "../../../tiamat/gleam/levenshtein.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $user_id from "../../data/auth/user_id.mjs";
import * as $data_point from "../../data/data_point.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $answer from "../../data/proposal_element/answer.mjs";
import * as $one_trust from "../../data/proposal_element/portal/one_trust.mjs";
import * as $translate from "../../data/translate.mjs";
import * as $language from "../../data/translate/language.mjs";
import * as $iso639 from "../../data/translate/language/iso639.mjs";
import * as $decrypt from "../../decrypt.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  divideFloat,
  isEqual,
} from "../../gleam.mjs";

const FILEPATH = "src/data/proposal_element/question.gleam";

export class Long extends $CustomType {}
export const AnswerKind$Long = () => new Long();
export const AnswerKind$isLong = (value) => value instanceof Long;

export class YesNo extends $CustomType {}
export const AnswerKind$YesNo = () => new YesNo();
export const AnswerKind$isYesNo = (value) => value instanceof YesNo;

export class MultipleChoice extends $CustomType {}
export const AnswerKind$MultipleChoice = () => new MultipleChoice();
export const AnswerKind$isMultipleChoice = (value) =>
  value instanceof MultipleChoice;

export class Display extends $CustomType {
  constructor(score, explanation) {
    super();
    this.score = score;
    this.explanation = explanation;
  }
}
export const Display$Display = (score, explanation) =>
  new Display(score, explanation);
export const Display$isDisplay = (value) => value instanceof Display;
export const Display$Display$score = (value) => value.score;
export const Display$Display$0 = (value) => value.score;
export const Display$Display$explanation = (value) => value.explanation;
export const Display$Display$1 = (value) => value.explanation;

export class Answer extends $CustomType {
  constructor(id, value, kind, choices, position, score, explanation, context_used, init_value, answer_style_id, header, instruction, column_role) {
    super();
    this.id = id;
    this.value = value;
    this.kind = kind;
    this.choices = choices;
    this.position = position;
    this.score = score;
    this.explanation = explanation;
    this.context_used = context_used;
    this.init_value = init_value;
    this.answer_style_id = answer_style_id;
    this.header = header;
    this.instruction = instruction;
    this.column_role = column_role;
  }
}
export const Answer$Answer = (id, value, kind, choices, position, score, explanation, context_used, init_value, answer_style_id, header, instruction, column_role) =>
  new Answer(id,
  value,
  kind,
  choices,
  position,
  score,
  explanation,
  context_used,
  init_value,
  answer_style_id,
  header,
  instruction,
  column_role);
export const Answer$isAnswer = (value) => value instanceof Answer;
export const Answer$Answer$id = (value) => value.id;
export const Answer$Answer$0 = (value) => value.id;
export const Answer$Answer$value = (value) => value.value;
export const Answer$Answer$1 = (value) => value.value;
export const Answer$Answer$kind = (value) => value.kind;
export const Answer$Answer$2 = (value) => value.kind;
export const Answer$Answer$choices = (value) => value.choices;
export const Answer$Answer$3 = (value) => value.choices;
export const Answer$Answer$position = (value) => value.position;
export const Answer$Answer$4 = (value) => value.position;
export const Answer$Answer$score = (value) => value.score;
export const Answer$Answer$5 = (value) => value.score;
export const Answer$Answer$explanation = (value) => value.explanation;
export const Answer$Answer$6 = (value) => value.explanation;
export const Answer$Answer$context_used = (value) => value.context_used;
export const Answer$Answer$7 = (value) => value.context_used;
export const Answer$Answer$init_value = (value) => value.init_value;
export const Answer$Answer$8 = (value) => value.init_value;
export const Answer$Answer$answer_style_id = (value) => value.answer_style_id;
export const Answer$Answer$9 = (value) => value.answer_style_id;
export const Answer$Answer$header = (value) => value.header;
export const Answer$Answer$10 = (value) => value.header;
export const Answer$Answer$instruction = (value) => value.instruction;
export const Answer$Answer$11 = (value) => value.instruction;
export const Answer$Answer$column_role = (value) => value.column_role;
export const Answer$Answer$12 = (value) => value.column_role;

export class Extraction extends $CustomType {}
export const ColumnRole$Extraction = () => new Extraction();
export const ColumnRole$isExtraction = (value) => value instanceof Extraction;

export class Descriptive extends $CustomType {}
export const ColumnRole$Descriptive = () => new Descriptive();
export const ColumnRole$isDescriptive = (value) => value instanceof Descriptive;

export class Attachment extends $CustomType {
  constructor(name, mime_type, id) {
    super();
    this.name = name;
    this.mime_type = mime_type;
    this.id = id;
  }
}
export const Attachment$Attachment = (name, mime_type, id) =>
  new Attachment(name, mime_type, id);
export const Attachment$isAttachment = (value) => value instanceof Attachment;
export const Attachment$Attachment$name = (value) => value.name;
export const Attachment$Attachment$0 = (value) => value.name;
export const Attachment$Attachment$mime_type = (value) => value.mime_type;
export const Attachment$Attachment$1 = (value) => value.mime_type;
export const Attachment$Attachment$id = (value) => value.id;
export const Attachment$Attachment$2 = (value) => value.id;

export class PortalQuestion extends $CustomType {
  constructor(question, section_name, attachments, additional_information) {
    super();
    this.question = question;
    this.section_name = section_name;
    this.attachments = attachments;
    this.additional_information = additional_information;
  }
}
export const Metadata$PortalQuestion = (question, section_name, attachments, additional_information) =>
  new PortalQuestion(question, section_name, attachments, additional_information);
export const Metadata$isPortalQuestion = (value) =>
  value instanceof PortalQuestion;
export const Metadata$PortalQuestion$question = (value) => value.question;
export const Metadata$PortalQuestion$0 = (value) => value.question;
export const Metadata$PortalQuestion$section_name = (value) =>
  value.section_name;
export const Metadata$PortalQuestion$1 = (value) => value.section_name;
export const Metadata$PortalQuestion$attachments = (value) => value.attachments;
export const Metadata$PortalQuestion$2 = (value) => value.attachments;
export const Metadata$PortalQuestion$additional_information = (value) =>
  value.additional_information;
export const Metadata$PortalQuestion$3 = (value) =>
  value.additional_information;

export class SheetQuestion extends $CustomType {
  constructor(position, sheet_name, attachments, numbering, section, context_question, google_sheet_gid, paragraph_id) {
    super();
    this.position = position;
    this.sheet_name = sheet_name;
    this.attachments = attachments;
    this.numbering = numbering;
    this.section = section;
    this.context_question = context_question;
    this.google_sheet_gid = google_sheet_gid;
    this.paragraph_id = paragraph_id;
  }
}
export const Metadata$SheetQuestion = (position, sheet_name, attachments, numbering, section, context_question, google_sheet_gid, paragraph_id) =>
  new SheetQuestion(position,
  sheet_name,
  attachments,
  numbering,
  section,
  context_question,
  google_sheet_gid,
  paragraph_id);
export const Metadata$isSheetQuestion = (value) =>
  value instanceof SheetQuestion;
export const Metadata$SheetQuestion$position = (value) => value.position;
export const Metadata$SheetQuestion$0 = (value) => value.position;
export const Metadata$SheetQuestion$sheet_name = (value) => value.sheet_name;
export const Metadata$SheetQuestion$1 = (value) => value.sheet_name;
export const Metadata$SheetQuestion$attachments = (value) => value.attachments;
export const Metadata$SheetQuestion$2 = (value) => value.attachments;
export const Metadata$SheetQuestion$numbering = (value) => value.numbering;
export const Metadata$SheetQuestion$3 = (value) => value.numbering;
export const Metadata$SheetQuestion$section = (value) => value.section;
export const Metadata$SheetQuestion$4 = (value) => value.section;
export const Metadata$SheetQuestion$context_question = (value) =>
  value.context_question;
export const Metadata$SheetQuestion$5 = (value) => value.context_question;
export const Metadata$SheetQuestion$google_sheet_gid = (value) =>
  value.google_sheet_gid;
export const Metadata$SheetQuestion$6 = (value) => value.google_sheet_gid;
export const Metadata$SheetQuestion$paragraph_id = (value) =>
  value.paragraph_id;
export const Metadata$SheetQuestion$7 = (value) => value.paragraph_id;

export const Metadata$attachments = (value) => value.attachments;

export class Question extends $CustomType {
  constructor(id, proposal_id, owner, content, answer, validated, metadata, ai_processing, assign_processing, qa_order, doc_id_order, parent_id, created_at, updated_at) {
    super();
    this.id = id;
    this.proposal_id = proposal_id;
    this.owner = owner;
    this.content = content;
    this.answer = answer;
    this.validated = validated;
    this.metadata = metadata;
    this.ai_processing = ai_processing;
    this.assign_processing = assign_processing;
    this.qa_order = qa_order;
    this.doc_id_order = doc_id_order;
    this.parent_id = parent_id;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }
}
export const Question$Question = (id, proposal_id, owner, content, answer, validated, metadata, ai_processing, assign_processing, qa_order, doc_id_order, parent_id, created_at, updated_at) =>
  new Question(id,
  proposal_id,
  owner,
  content,
  answer,
  validated,
  metadata,
  ai_processing,
  assign_processing,
  qa_order,
  doc_id_order,
  parent_id,
  created_at,
  updated_at);
export const Question$isQuestion = (value) => value instanceof Question;
export const Question$Question$id = (value) => value.id;
export const Question$Question$0 = (value) => value.id;
export const Question$Question$proposal_id = (value) => value.proposal_id;
export const Question$Question$1 = (value) => value.proposal_id;
export const Question$Question$owner = (value) => value.owner;
export const Question$Question$2 = (value) => value.owner;
export const Question$Question$content = (value) => value.content;
export const Question$Question$3 = (value) => value.content;
export const Question$Question$answer = (value) => value.answer;
export const Question$Question$4 = (value) => value.answer;
export const Question$Question$validated = (value) => value.validated;
export const Question$Question$5 = (value) => value.validated;
export const Question$Question$metadata = (value) => value.metadata;
export const Question$Question$6 = (value) => value.metadata;
export const Question$Question$ai_processing = (value) => value.ai_processing;
export const Question$Question$7 = (value) => value.ai_processing;
export const Question$Question$assign_processing = (value) =>
  value.assign_processing;
export const Question$Question$8 = (value) => value.assign_processing;
export const Question$Question$qa_order = (value) => value.qa_order;
export const Question$Question$9 = (value) => value.qa_order;
export const Question$Question$doc_id_order = (value) => value.doc_id_order;
export const Question$Question$10 = (value) => value.doc_id_order;
export const Question$Question$parent_id = (value) => value.parent_id;
export const Question$Question$11 = (value) => value.parent_id;
export const Question$Question$created_at = (value) => value.created_at;
export const Question$Question$12 = (value) => value.created_at;
export const Question$Question$updated_at = (value) => value.updated_at;
export const Question$Question$13 = (value) => value.updated_at;

export class AdditionalInformation extends $CustomType {
  constructor(section, numbering) {
    super();
    this.section = section;
    this.numbering = numbering;
  }
}
export const AdditionalInformation$AdditionalInformation = (section, numbering) =>
  new AdditionalInformation(section, numbering);
export const AdditionalInformation$isAdditionalInformation = (value) =>
  value instanceof AdditionalInformation;
export const AdditionalInformation$AdditionalInformation$section = (value) =>
  value.section;
export const AdditionalInformation$AdditionalInformation$0 = (value) =>
  value.section;
export const AdditionalInformation$AdditionalInformation$numbering = (value) =>
  value.numbering;
export const AdditionalInformation$AdditionalInformation$1 = (value) =>
  value.numbering;

export class NewLongAnswer extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const LongAnswerChange$NewLongAnswer = ($0) => new NewLongAnswer($0);
export const LongAnswerChange$isNewLongAnswer = (value) =>
  value instanceof NewLongAnswer;
export const LongAnswerChange$NewLongAnswer$0 = (value) => value[0];

export class ChangedLongAnswer extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const LongAnswerChange$ChangedLongAnswer = ($0) =>
  new ChangedLongAnswer($0);
export const LongAnswerChange$isChangedLongAnswer = (value) =>
  value instanceof ChangedLongAnswer;
export const LongAnswerChange$ChangedLongAnswer$0 = (value) => value[0];

export function column_role_to_string(role) {
  if (role instanceof Extraction) {
    return "extraction";
  } else {
    return "descriptive";
  }
}

export function column_role_decoder() {
  return $decode.then$(
    $decode.string,
    (role) => {
      if (role === "extraction") {
        return $decode.success(new Extraction());
      } else if (role === "descriptive") {
        return $decode.success(new Descriptive());
      } else {
        return $decode.failure(new Extraction(), "ColumnRole");
      }
    },
  );
}

export function no_information() {
  return new AdditionalInformation(toList([]), toList([]));
}

function attachment_decoder() {
  return $decode.field(
    "name",
    $decode.string,
    (name) => {
      return $decode.field(
        "mime_type",
        $decode.string,
        (mime_type) => {
          return $decode.field(
            "id",
            $decode.string,
            (id) => {
              return $decode.success(new Attachment(name, mime_type, id));
            },
          );
        },
      );
    },
  );
}

/**
 * Due to legacy reasons, `sheet` was previously stored at the top-level.
 * `question_sheet_name` now tries to read `metadata.sheet_name` in priority,
 * and fallback on `question.sheet` if not found.
 * 
 * @ignore
 */
function question_sheet_name(sheet) {
  return $decrypt.optional_field(
    "sheet_name",
    $decode.string,
    (sheet_name) => {
      let sheet_name$1 = $option.or(sheet_name, sheet);
      return $decode.success(sheet_name$1);
    },
  );
}

export function position_decoder() {
  return $decode.field(
    "x",
    $decode.int,
    (x) => {
      return $decode.field(
        "y",
        $decode.int,
        (y) => { return $decode.success([x, y]); },
      );
    },
  );
}

/**
 * Due to legacy reasons, `position` was previously encoded as `x` and `y`
 * separatedly. `question_position_decoder` still keeps both decoding, to
 * fallback on legacy system when `position` is not found. This avoids to
 * migrate the legacy data.
 * 
 * @ignore
 */
function question_position_decoder() {
  return $decrypt.optional_field(
    "position",
    position_decoder(),
    (position) => {
      return $decrypt.optional_field(
        "x",
        $decode.int,
        (x) => {
          return $decrypt.optional_field(
            "y",
            $decode.int,
            (y) => {
              let _pipe = $option.lazy_or(
                position,
                () => {
                  return $option.then$(
                    x,
                    (x) => {
                      return $option.then$(
                        y,
                        (y) => { return new Some([x, y]); },
                      );
                    },
                  );
                },
              );
              return $decode.success(_pipe);
            },
          );
        },
      );
    },
  );
}

function metadata_sheet_question_decoder(sheet) {
  return $decode.then$(
    question_position_decoder(),
    (position) => {
      return $decode.then$(
        question_sheet_name(sheet),
        (sheet_name) => {
          let attachments = $decode.list(attachment_decoder());
          return $decrypt.optional_field(
            "attachments",
            attachments,
            (attachments) => {
              let attachments$1 = $option.unwrap(attachments, toList([]));
              return $decrypt.optional_field(
                "numbering",
                (() => {
                  let _pipe = $decode.one_of(
                    $decode.list($decode.string),
                    toList([
                      (() => {
                        let _pipe = $decode.string;
                        return $decode.map(_pipe, $list.wrap);
                      })(),
                    ]),
                  );
                  return $decode.collapse_errors(_pipe, "List(String)");
                })(),
                (numbering) => {
                  let numbering$1 = $option.unwrap(numbering, toList([]));
                  return $decrypt.optional_field(
                    "section",
                    $decode.string,
                    (section) => {
                      return $decrypt.optional_field(
                        "google_sheet_gid",
                        $decode.string,
                        (google_sheet_gid) => {
                          return $decrypt.optional_field(
                            "context_question",
                            $decode.string,
                            (context_question) => {
                              return $decrypt.optional_field(
                                "paragraph_id",
                                $decode.string,
                                (paragraph_id) => {
                                  return $decode.success(
                                    new SheetQuestion(
                                      position,
                                      sheet_name,
                                      attachments$1,
                                      numbering$1,
                                      section,
                                      context_question,
                                      google_sheet_gid,
                                      paragraph_id,
                                    ),
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function metadata_portal_question_decoder() {
  return $decode.field(
    "question",
    $one_trust.question_decoder(),
    (question) => {
      return $decode.field(
        "section_name",
        $decode.string,
        (section_name) => {
          return $decrypt.optional_field(
            "additional_information",
            (() => {
              let _pipe = $decode.one_of(
                $decode.list($decode.string),
                toList([
                  (() => {
                    let _pipe = $decode.string;
                    return $decode.map(_pipe, $list.wrap);
                  })(),
                ]),
              );
              return $decode.collapse_errors(_pipe, "List(String)");
            })(),
            (additional_information) => {
              let _block;
              let _pipe = additional_information;
              _block = $option.unwrap(_pipe, toList([]));
              let additional_information$1 = _block;
              let attachments = $decode.list(attachment_decoder());
              return $decrypt.optional_field(
                "attachments",
                attachments,
                (attachments) => {
                  let attachments$1 = $option.unwrap(attachments, toList([]));
                  return $decode.success(
                    new PortalQuestion(
                      question,
                      section_name,
                      attachments$1,
                      additional_information$1,
                    ),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function metadata_decoder(sheet) {
  return $decrypt.optional_field(
    "type",
    $decode.string,
    (kind) => {
      if (kind instanceof Some) {
        let $ = kind[0];
        if ($ === "portal") {
          return metadata_portal_question_decoder();
        } else if ($ === "question") {
          return metadata_sheet_question_decoder(sheet);
        } else {
          let kind$1 = new $one_trust.Button();
          let answer = new $one_trust.AnswerInputText("");
          let default$ = new $one_trust.Question(
            "",
            "",
            "",
            kind$1,
            "",
            0,
            answer,
          );
          let default$1 = new PortalQuestion(
            default$,
            "",
            toList([]),
            toList([]),
          );
          return $decode.failure(default$1, "Metadata");
        }
      } else {
        return metadata_sheet_question_decoder(sheet);
      }
    },
  );
}

export function answer_kind_decoder() {
  return $decode.then$(
    $decode.string,
    (answer_kind) => {
      if (answer_kind === "long") {
        return $decode.success(new Long());
      } else if (answer_kind === "short") {
        return $decode.success(new Long());
      } else if (answer_kind === "custom") {
        return $decode.success(new Long());
      } else if (answer_kind === "textual-answer") {
        return $decode.success(new Long());
      } else if (answer_kind === "textual_answer") {
        return $decode.success(new Long());
      } else if (answer_kind === "unknown") {
        return $decode.success(new Long());
      } else if (answer_kind === "yes-no") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes_no") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes_no_answer") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes-no-answer") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "multiple-choice") {
        return $decode.success(new MultipleChoice());
      } else if (answer_kind === "choice") {
        return $decode.success(new MultipleChoice());
      } else {
        return $decode.failure(new Long(), "AnswerKind");
      }
    },
  );
}

/**
 * `legacy_context_used : #(Score, Explanation, Data Points ID)`
 * 
 * @ignore
 */
function answer_decoder(legacy_choices, legacy_context_used) {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decrypt.optional_field(
        "value",
        $decode.string,
        (value) => {
          return $decode.field(
            "kind",
            answer_kind_decoder(),
            (kind) => {
              return $decrypt.optional_field(
                "position",
                position_decoder(),
                (position) => {
                  return $decrypt.optional_field(
                    "choices",
                    $decode.list($decode.string),
                    (choices) => {
                      return $decrypt.optional_field(
                        "context_used",
                        $data_point.ids_decoder(),
                        (context_used) => {
                          return $decrypt.optional_field(
                            "score",
                            $decrypt.float(),
                            (score) => {
                              return $decrypt.optional_field(
                                "explanation",
                                $decode.string,
                                (explanation) => {
                                  let _block;
                                  if (kind instanceof Long) {
                                    _block = choices;
                                  } else if (kind instanceof YesNo) {
                                    _block = choices;
                                  } else if (choices instanceof Some) {
                                    _block = choices;
                                  } else if (legacy_choices instanceof Some) {
                                    _block = legacy_choices;
                                  } else {
                                    _block = choices;
                                  }
                                  let choices$1 = _block;
                                  let _block$1;
                                  let $1 = legacy_context_used[0];
                                  if (score instanceof Some) {
                                    _block$1 = [
                                      score,
                                      explanation,
                                      context_used,
                                    ];
                                  } else if ($1 instanceof Some) {
                                    _block$1 = legacy_context_used;
                                  } else {
                                    _block$1 = [
                                      score,
                                      explanation,
                                      context_used,
                                    ];
                                  }
                                  let $ = _block$1;
                                  let score$1 = $[0];
                                  let explanation$1 = $[1];
                                  let context_used$1 = $[2];
                                  let _block$2;
                                  let _pipe = context_used$1;
                                  _block$2 = $option.unwrap(_pipe, toList([]));
                                  let context_used$2 = _block$2;
                                  let _block$3;
                                  let _pipe$1 = explanation$1;
                                  _block$3 = $option.or(
                                    _pipe$1,
                                    legacy_context_used[1],
                                  );
                                  let explanation$2 = _block$3;
                                  return $decrypt.optional_field(
                                    "init_value",
                                    $decode.string,
                                    (init_value) => {
                                      return $decrypt.optional_field(
                                        "answer_style_id",
                                        $decode.string,
                                        (answer_style_id) => {
                                          return $decrypt.optional_field(
                                            "header",
                                            $decode.string,
                                            (header) => {
                                              return $decrypt.optional_field(
                                                "instruction",
                                                $decode.string,
                                                (instruction) => {
                                                  return $decrypt.optional_field(
                                                    "column_role",
                                                    column_role_decoder(),
                                                    (column_role) => {
                                                      if (value instanceof Some) {
                                                        let value$1 = value[0];
                                                        return $decode.success(
                                                          new Ok(
                                                            new Answer(
                                                              id,
                                                              value$1,
                                                              kind,
                                                              choices$1,
                                                              position,
                                                              score$1,
                                                              explanation$2,
                                                              context_used$2,
                                                              init_value,
                                                              answer_style_id,
                                                              header,
                                                              instruction,
                                                              column_role,
                                                            ),
                                                          ),
                                                        );
                                                      } else {
                                                        return $decode.success(
                                                          new Error(undefined),
                                                        );
                                                      }
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function legacy_context_used() {
  return $decrypt.optional_field(
    "display",
    $decrypt.json(
      $decode.field(
        "score",
        $decode.optional($decrypt.float()),
        (score) => {
          return $decrypt.optional_field(
            "explanation",
            $decode.string,
            (explanation) => {
              return $decode.success(new Display(score, explanation));
            },
          );
        },
      ),
    ),
    (display) => {
      let display$1 = $option.unwrap(
        display,
        new Display(new None(), new None()),
      );
      return $decrypt.optional_field(
        "data_points_id",
        (() => {
          let _pipe = $decode.optional($decrypt.json($data_point.ids_decoder()));
          return $decode.map(
            _pipe,
            (_capture) => { return $option.unwrap(_capture, toList([])); },
          );
        })(),
        (data_points_id) => {
          return $decode.success(
            [display$1.score, display$1.explanation, data_points_id],
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "element_type",
    $kind.question_decoder(),
    (_) => {
      return $decode.field(
        "id",
        $decrypt.uuid(),
        (id) => {
          return $decode.field(
            "proposal_id",
            $decrypt.uuid(),
            (proposal_id) => {
              return $decode.field(
                "owner",
                $decode.optional($user_id.decoder()),
                (owner) => {
                  return $decrypt.optional_field(
                    "sheet",
                    $decode.string,
                    (sheet) => {
                      return $decode.field(
                        "content",
                        $decode.string,
                        (content) => {
                          return $decode.then$(
                            legacy_context_used(),
                            (legacy_context_used) => {
                              return $decrypt.optional_field(
                                "choices",
                                $decode.list($decode.string),
                                (legacy_choices) => {
                                  return $decode.field(
                                    "answer",
                                    (() => {
                                      let _pipe = answer_decoder(
                                        legacy_choices,
                                        legacy_context_used,
                                      );
                                      let _pipe$1 = $decrypt.filter_list(_pipe);
                                      let _pipe$2 = $decrypt.json(_pipe$1);
                                      let _pipe$3 = $decode.map(
                                        _pipe$2,
                                        (_capture) => {
                                          return $list.map(
                                            _capture,
                                            (v) => { return [v.id, v]; },
                                          );
                                        },
                                      );
                                      return $decode.map(
                                        _pipe$3,
                                        $dict.from_list,
                                      );
                                    })(),
                                    (answer) => {
                                      return $decode.field(
                                        "validated",
                                        $decode.bool,
                                        (validated) => {
                                          return $decode.field(
                                            "metadata",
                                            $decrypt.json(
                                              metadata_decoder(sheet),
                                            ),
                                            (metadata) => {
                                              return $decode.field(
                                                "ai_processing",
                                                $decode.bool,
                                                (ai_processing) => {
                                                  return $decode.field(
                                                    "assign_processing",
                                                    $decode.bool,
                                                    (assign_processing) => {
                                                      return $decode.field(
                                                        "qa_order",
                                                        $decode.int,
                                                        (qa_order) => {
                                                          return $decode.field(
                                                            "doc_id_order",
                                                            $decode.int,
                                                            (doc_id_order) => {
                                                              return $decrypt.optional_field(
                                                                "parent_id",
                                                                $decrypt.uuid(),
                                                                (parent_id) => {
                                                                  return $decrypt.optional_field(
                                                                    "updated_at",
                                                                    $decrypt.timestamp(),
                                                                    (
                                                                        updated_at_opt
                                                                      ) => {
                                                                      let updated_at = $option.unwrap(
                                                                        updated_at_opt,
                                                                        $timestamp.system_time(),
                                                                      );
                                                                      return $decrypt.optional_field(
                                                                        "created_at",
                                                                        $decrypt.timestamp(),
                                                                        (
                                                                            created_at_opt
                                                                          ) => {
                                                                          let created_at = $option.unwrap(
                                                                            created_at_opt,
                                                                            $timestamp.system_time(),
                                                                          );
                                                                          return $decode.success(
                                                                            new Question(
                                                                              id,
                                                                              proposal_id,
                                                                              owner,
                                                                              content,
                                                                              answer,
                                                                              validated,
                                                                              metadata,
                                                                              ai_processing,
                                                                              assign_processing,
                                                                              qa_order,
                                                                              doc_id_order,
                                                                              parent_id,
                                                                              created_at,
                                                                              updated_at,
                                                                            ),
                                                                          );
                                                                        },
                                                                      );
                                                                    },
                                                                  );
                                                                },
                                                              );
                                                            },
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * The first answer of a kind, **ignoring styled variants**. "The" answer of a
 * question has always meant the main one, and so does every reader built on
 * this: `get_textual_answer`, `get_answer_text`, `explanation`, `get_answer`,
 * `update_custom_answer`. Filtering here rather than at each of them means a
 * reader written later is right by default.
 *
 * This is a strict no-op until an org configures answer styles: with no
 * style configured, no answer carries one.
 *
 * It does not disambiguate two *unstyled* `Long` answers — that is SL-9, and
 * `multiple_textual_answers_test.gleam` still documents it.
 */
export function get_first_answer_of_kind(question, kind) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  return $list.find(
    _pipe$1,
    (v) => {
      return (isEqual(v.kind, kind)) && $option.is_none(v.answer_style_id);
    },
  );
}

export function translate_question_and_answers(q, translations, language) {
  let language_iso639 = $iso639.to_string(language);
  let held_text = (key) => {
    let _pipe = translations;
    let _pipe$1 = $dict.get(_pipe, key);
    let _pipe$2 = $result.try$(
      _pipe$1,
      (t) => {
        let $ = $translate.holds_translation(t);
        if ($) {
          return new Ok(t.content);
        } else {
          return new Error(undefined);
        }
      },
    );
    return $option.from_result(_pipe$2);
  };
  let s = $translate.translation_target_to_small_string(
    new $translate.Question(),
  );
  let _block;
  let _pipe = held_text($string.join(toList([language_iso639, s, q.id]), "_"));
  _block = $option.unwrap(_pipe, q.content);
  let content = _block;
  let _block$1;
  let _pipe$1 = get_first_answer_of_kind(q, new Long());
  _block$1 = $result.map(_pipe$1, (a) => { return a.id; });
  let canonical_long_answer_id = _block$1;
  let answer = $dict.map_values(
    q.answer,
    (_, answer_value) => {
      let $ = answer_value.kind;
      if ($ instanceof Long) {
        let is_canonical = isEqual(
          new Ok(answer_value.id),
          canonical_long_answer_id
        );
        let prefix = $translate.translation_target_to_small_string(
          new $translate.Answer(),
        );
        let by_answer_id = held_text(
          $string.join(toList([language_iso639, prefix, answer_value.id]), "_"),
        );
        let legacy_fallback = () => {
          if (is_canonical) {
            return held_text(
              $string.join(toList([language_iso639, prefix, q.id]), "_"),
            );
          } else {
            return new $option.None();
          }
        };
        let _block$2;
        let _pipe$2 = by_answer_id;
        let _pipe$3 = $option.lazy_or(_pipe$2, legacy_fallback);
        _block$2 = $option.unwrap(_pipe$3, answer_value.value);
        let value = _block$2;
        return new Answer(
          answer_value.id,
          value,
          answer_value.kind,
          answer_value.choices,
          answer_value.position,
          answer_value.score,
          answer_value.explanation,
          answer_value.context_used,
          answer_value.init_value,
          answer_value.answer_style_id,
          answer_value.header,
          answer_value.instruction,
          answer_value.column_role,
        );
      } else if ($ instanceof YesNo) {
        return new Answer(
          answer_value.id,
          (() => {
            let $1 = answer_value.value;
            if ($1 === "YES") {
              return $language.to_yes(language);
            } else if ($1 === "NO") {
              return $language.to_no(language);
            } else if ($1 === "N/A") {
              return $language.to_na(language);
            } else {
              return $language.to_na(language);
            }
          })(),
          answer_value.kind,
          answer_value.choices,
          answer_value.position,
          answer_value.score,
          answer_value.explanation,
          answer_value.context_used,
          answer_value.init_value,
          answer_value.answer_style_id,
          answer_value.header,
          answer_value.instruction,
          answer_value.column_role,
        );
      } else {
        let translated_choice = (label) => {
          let $1 = $string.is_empty(label);
          if ($1) {
            return label;
          } else {
            let _pipe$2 = held_text(
              $translate.choice_lookup_key(label, language),
            );
            return $option.unwrap(_pipe$2, label);
          }
        };
        return new Answer(
          answer_value.id,
          translated_choice(answer_value.value),
          answer_value.kind,
          $option.map(
            answer_value.choices,
            (_capture) => { return $list.map(_capture, translated_choice); },
          ),
          answer_value.position,
          answer_value.score,
          answer_value.explanation,
          answer_value.context_used,
          answer_value.init_value,
          answer_value.answer_style_id,
          answer_value.header,
          answer_value.instruction,
          answer_value.column_role,
        );
      }
    },
  );
  return new Question(
    q.id,
    q.proposal_id,
    q.owner,
    content,
    answer,
    q.validated,
    q.metadata,
    q.ai_processing,
    q.assign_processing,
    q.qa_order,
    q.doc_id_order,
    q.parent_id,
    q.created_at,
    q.updated_at,
  );
}

export function encode_additional_information() {
  return $json.object(
    toList([
      ["previous_questions", $json.preprocessed_array(toList([]))],
      ["other", $json.preprocessed_array(toList([]))],
    ]),
  );
}

function encode_position(position) {
  return $json.object(
    toList([["x", $json.int(position[0])], ["y", $json.int(position[1])]]),
  );
}

export function answer_kind_to_string(q) {
  if (q instanceof Long) {
    return "long";
  } else if (q instanceof YesNo) {
    return "yes-no";
  } else {
    return "multiple-choice";
  }
}

export function encode_answer_kind(q) {
  let _pipe = answer_kind_to_string(q);
  return $json.string(_pipe);
}

export function encode_answer_values(values) {
  let values$1 = $dict.to_list(values);
  return $json.array(
    values$1,
    (_use0) => {
      let value = _use0[1];
      return $json.object(
        toList([
          ["id", $json.string(value.id)],
          ["value", $json.string(value.value)],
          ["kind", encode_answer_kind(value.kind)],
          [
            "choices",
            $json.nullable(
              value.choices,
              (_capture) => { return $json.array(_capture, $json.string); },
            ),
          ],
          ["position", $json.nullable(value.position, encode_position)],
          ["score", $json.nullable(value.score, $json.float)],
          ["explanation", $json.nullable(value.explanation, $json.string)],
          ["context_used", $data_point.ids_encode(value.context_used)],
          ["init_value", $json.nullable(value.init_value, $json.string)],
          [
            "answer_style_id",
            $json.nullable(value.answer_style_id, $json.string),
          ],
          ["header", $json.nullable(value.header, $json.string)],
          ["instruction", $json.nullable(value.instruction, $json.string)],
          [
            "column_role",
            $json.nullable(
              value.column_role,
              (role) => { return $json.string(column_role_to_string(role)); },
            ),
          ],
        ]),
      );
    },
  );
}

export function explanation(question) {
  let _pipe = get_first_answer_of_kind(question, new Long());
  let _pipe$1 = $result.lazy_or(
    _pipe,
    () => { return get_first_answer_of_kind(question, new MultipleChoice()); },
  );
  let _pipe$2 = $result.lazy_or(
    _pipe$1,
    () => { return get_first_answer_of_kind(question, new YesNo()); },
  );
  let _pipe$3 = $result.map(_pipe$2, (val) => { return val.explanation; });
  return $result.unwrap(_pipe$3, new None());
}

export function score(question) {
  let $ = $dict.fold(
    question.answer,
    [new None(), 0],
    (value, _, answer) => {
      let value$1 = value[0];
      let count = value[1];
      let $1 = answer.score;
      if (value$1 instanceof Some) {
        if ($1 instanceof Some) {
          let value$2 = value$1[0];
          let score$1 = $1[0];
          return [new Some(value$2 + score$1), count + 1];
        } else {
          let value$2 = value$1[0];
          return [new Some(value$2), count];
        }
      } else if ($1 instanceof Some) {
        let score$1 = $1[0];
        return [new Some(score$1), 1];
      } else {
        return [new None(), 0];
      }
    },
  );
  let avg = $[0];
  let count = $[1];
  if (avg instanceof Some) {
    let avg$1 = avg[0];
    return new Some(divideFloat(avg$1, $int.to_float(count)));
  } else {
    return avg;
  }
}

export function encode_display(question) {
  return $json.object(
    toList([
      ["score", $json.nullable(score(question), $json.float)],
      ["explanation", $json.nullable(explanation(question), $json.string)],
    ]),
  );
}

export function sheet(question) {
  let $ = question.metadata;
  if ($ instanceof PortalQuestion) {
    return new None();
  } else {
    let metadata = $;
    return metadata.sheet_name;
  }
}

export function kinds(question) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.fold(
    _pipe,
    $set.new$(),
    (kind, _, value) => { return $set.insert(kind, value.kind); },
  );
  return $set.to_list(_pipe$1);
}

export function encode_attachment(attachment) {
  return $json.object(
    toList([
      ["name", $json.string(attachment.name)],
      ["mime_type", $json.string(attachment.mime_type)],
      ["id", $json.string(attachment.id)],
    ]),
  );
}

export function encode_metadata(metadata) {
  if (metadata instanceof PortalQuestion) {
    return $json.object(
      toList([
        ["type", $json.string("portal")],
        ["question", $one_trust.encode_question(metadata.question)],
        ["section_name", $json.string(metadata.section_name)],
        ["language", $json.null$()],
        [
          "additional_information",
          $json.array(metadata.additional_information, $json.string),
        ],
        [
          "attachments",
          $json.array(
            metadata.attachments,
            (attachment) => { return encode_attachment(attachment); },
          ),
        ],
      ]),
    );
  } else {
    return $json.object(
      toList([
        ["type", $json.string("question")],
        [
          "google_sheet_gid",
          $json.nullable(metadata.google_sheet_gid, $json.string),
        ],
        ["position", $json.nullable(metadata.position, encode_position)],
        [
          "x",
          $json.nullable(metadata.position, (p) => { return $json.int(p[0]); }),
        ],
        [
          "y",
          $json.nullable(metadata.position, (p) => { return $json.int(p[1]); }),
        ],
        ["language", $json.null$()],
        [
          "attachments",
          $json.array(
            metadata.attachments,
            (attachment) => { return encode_attachment(attachment); },
          ),
        ],
        ["sheet_name", $json.nullable(metadata.sheet_name, $json.string)],
        ["numbering", $json.array(metadata.numbering, $json.string)],
        ["section", $json.nullable(metadata.section, $json.string)],
        [
          "context_question",
          $json.nullable(metadata.context_question, $json.string),
        ],
        ["paragraph_id", $json.nullable(metadata.paragraph_id, $json.string)],
        ["additional_information", encode_additional_information()],
      ]),
    );
  }
}

export function context_used(question) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.fold(
    _pipe,
    $set.new$(),
    (dps, _, answer) => {
      return $list.fold(answer.context_used, dps, $set.insert);
    },
  );
  let _pipe$2 = $set.to_list(_pipe$1);
  return $list.sort(_pipe$2, (a, b) => { return $float.compare(a[1], b[1]); });
}

export function encode(question) {
  let _block;
  let _pipe = question;
  let _pipe$1 = get_first_answer_of_kind(_pipe, new MultipleChoice());
  let _pipe$2 = $option.from_result(_pipe$1);
  let _pipe$3 = $option.then$(_pipe$2, (a) => { return a.choices; });
  _block = $option.unwrap(_pipe$3, toList([]));
  let choices = _block;
  return $json.object(
    toList([
      ["__version", $json.int(1)],
      ["element_type", $kind.encode(new $kind.Question())],
      ["id", $json.string(question.id)],
      ["proposal_id", $json.string(question.proposal_id)],
      [
        "data_points_id",
        $json.array(
          context_used(question),
          (_use0) => {
            let id = _use0[0];
            let score$1 = _use0[1];
            return $json.object(
              toList([
                ["data_point_id", $json.string(id)],
                ["score", $json.float(score$1)],
              ]),
            );
          },
        ),
      ],
      ["owner", $json.nullable(question.owner, $user_id.encode)],
      ["content", $json.string(question.content)],
      ["answer", encode_answer_values(question.answer)],
      ["validated", $json.bool(question.validated)],
      ["metadata", encode_metadata(question.metadata)],
      ["ai_processing", $json.bool(question.ai_processing)],
      ["assign_processing", $json.bool(question.assign_processing)],
      ["qa_order", $json.int(question.qa_order)],
      ["doc_id_order", $json.int(question.doc_id_order)],
      ["parent_id", $json.nullable(question.parent_id, $json.string)],
      ["updated_at", $json_.to_rfc3339(question.updated_at)],
      ["created_at", $json_.to_rfc3339(question.created_at)],
      ["kind", $json.array(kinds(question), encode_answer_kind)],
      ["choices", $json.array(choices, $json.string)],
      ["sheet", $json.nullable(sheet(question), $json.string)],
      ["display", encode_display(question)],
    ]),
  );
}

export function get_answer_text(question) {
  let _pipe = get_first_answer_of_kind(question, new Long());
  let _pipe$1 = $result.lazy_or(
    _pipe,
    () => { return get_first_answer_of_kind(question, new MultipleChoice()); },
  );
  let _pipe$2 = $result.lazy_or(
    _pipe$1,
    () => { return get_first_answer_of_kind(question, new YesNo()); },
  );
  let _pipe$3 = $result.map(_pipe$2, (val) => { return val.value; });
  return $result.unwrap(_pipe$3, "");
}

function ignore_empty_string(answer) {
  if (answer instanceof Some) {
    let $ = answer[0];
    if ($ === "") {
      return new None();
    } else {
      return answer;
    }
  } else {
    return answer;
  }
}

export function answer_value(answer, default_language) {
  let $ = answer.kind;
  if ($ instanceof Long) {
    return answer.value;
  } else if ($ instanceof YesNo) {
    let _pipe = answer.value;
    let _pipe$1 = $translate.parse_yes_no(_pipe);
    let _pipe$2 = $result.map(
      _pipe$1,
      (_capture) => {
        return $translate.yes_no_answer(_capture, default_language);
      },
    );
    return $result.unwrap(_pipe$2, answer.value);
  } else {
    return answer.value;
  }
}

export function get_answer(question, kind, default_language) {
  let _pipe = question;
  let _pipe$1 = get_first_answer_of_kind(_pipe, kind);
  let _pipe$2 = $result.map(
    _pipe$1,
    (_capture) => { return answer_value(_capture, default_language); },
  );
  let _pipe$3 = $option.from_result(_pipe$2);
  return ignore_empty_string(_pipe$3);
}

function concatenate_answer_types(answers) {
  let _pipe = answers;
  let _pipe$1 = $dict.to_list(_pipe);
  let _pipe$2 = $list.map(_pipe$1, (a) => { return a[1].value; });
  return $string.join(_pipe$2, " ");
}

export function serialize(question) {
  let all_answer_types = concatenate_answer_types(question.answer);
  return $string.join(toList([question.content, all_answer_types]), "");
}

export function default_kinds(kinds) {
  let $ = $list.is_empty(kinds);
  if ($) {
    return toList([new Long()]);
  } else {
    return kinds;
  }
}

export function is_hint(question) {
  return $dict.is_empty(question.answer);
}

function keep_initial_value(answer) {
  let $ = answer.score;
  let $1 = answer.init_value;
  if ($ instanceof Some) {
    if ($1 instanceof Some) {
      return answer;
    } else {
      return new Answer(
        answer.id,
        answer.value,
        answer.kind,
        answer.choices,
        answer.position,
        answer.score,
        answer.explanation,
        answer.context_used,
        new Some(answer.value),
        answer.answer_style_id,
        answer.header,
        answer.instruction,
        answer.column_role,
      );
    }
  } else {
    return answer;
  }
}

function update_answers(question, updater) {
  let answer = updater(question.answer);
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    answer,
    question.validated,
    question.metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

/**
 * `answer_style_id` labels the slot when it has to be created — nabu answers
 * one task per style, and the slot for a styled variant may not exist yet.
 * An existing slot keeps the style it was created with: the style belongs to
 * the slot, not to the version being written into it.
 */
export function update_textual_answer(
  question,
  id,
  value,
  score,
  explanation,
  context_used,
  answer_style_id
) {
  return update_answers(
    question,
    (answers) => {
      return $dict.upsert(
        answers,
        id,
        (answer) => {
          if (answer instanceof Some) {
            let answer$1 = answer[0];
            let _pipe = new Answer(
              answer$1.id,
              value,
              answer$1.kind,
              answer$1.choices,
              answer$1.position,
              score,
              explanation,
              context_used,
              answer$1.init_value,
              answer$1.answer_style_id,
              answer$1.header,
              answer$1.instruction,
              answer$1.column_role,
            );
            return keep_initial_value(_pipe);
          } else {
            return new Answer(
              id,
              value,
              new Long(),
              new None(),
              new None(),
              score,
              explanation,
              context_used,
              new Some(value),
              answer_style_id,
              new None(),
              new None(),
              new None(),
            );
          }
        },
      );
    },
  );
}

export function update_custom_answer(question, value) {
  let $ = get_first_answer_of_kind(question, new Long());
  if ($ instanceof Ok) {
    let answer = $[0];
    return update_textual_answer(
      question,
      answer.id,
      value,
      answer.score,
      answer.explanation,
      answer.context_used,
      answer.answer_style_id,
    );
  } else {
    return question;
  }
}

export function update_yes_no_answer(
  question,
  id,
  value,
  score,
  explanation,
  context_used
) {
  return update_answers(
    question,
    (answers) => {
      return $dict.upsert(
        answers,
        id,
        (answer) => {
          if (answer instanceof Some) {
            let answer$1 = answer[0];
            let _pipe = new Answer(
              answer$1.id,
              value,
              answer$1.kind,
              answer$1.choices,
              answer$1.position,
              score,
              explanation,
              context_used,
              answer$1.init_value,
              answer$1.answer_style_id,
              answer$1.header,
              answer$1.instruction,
              answer$1.column_role,
            );
            return keep_initial_value(_pipe);
          } else {
            return new Answer(
              id,
              value,
              new YesNo(),
              new None(),
              new None(),
              score,
              explanation,
              context_used,
              new Some(value),
              new None(),
              new None(),
              new None(),
              new None(),
            );
          }
        },
      );
    },
  );
}

export function update_multiple_choice_answer(
  question,
  id,
  value,
  score,
  explanation,
  context_used
) {
  return update_answers(
    question,
    (answers) => {
      return $dict.upsert(
        answers,
        id,
        (choice) => {
          if (choice instanceof Some) {
            let answer = choice[0];
            let _pipe = new Answer(
              answer.id,
              value,
              answer.kind,
              answer.choices,
              answer.position,
              score,
              explanation,
              context_used,
              answer.init_value,
              answer.answer_style_id,
              answer.header,
              answer.instruction,
              answer.column_role,
            );
            return keep_initial_value(_pipe);
          } else {
            return new Answer(
              id,
              value,
              new MultipleChoice(),
              new None(),
              new None(),
              score,
              explanation,
              context_used,
              new Some(value),
              new None(),
              new None(),
              new None(),
              new None(),
            );
          }
        },
      );
    },
  );
}

/**
 * Sets the AI-generated per-column instruction and its column role on one
 * answer slot (SL-9 follow-up), once nabu's async generation responds. A
 * no-op when the answer no longer exists (e.g. it was removed by a later
 * mapping edit while the generation was in flight).
 */
export function set_answer_instruction(question, id, instruction, column_role) {
  return update_answers(
    question,
    (answers) => {
      let $ = $dict.get(answers, id);
      if ($ instanceof Ok) {
        let answer = $[0];
        return $dict.insert(
          answers,
          id,
          new Answer(
            answer.id,
            answer.value,
            answer.kind,
            answer.choices,
            answer.position,
            answer.score,
            answer.explanation,
            answer.context_used,
            answer.init_value,
            answer.answer_style_id,
            answer.header,
            new Some(instruction),
            column_role,
          ),
        );
      } else {
        return answers;
      }
    },
  );
}

export function set_parent_id(question, parent_id) {
  let parent_id$1 = new Some(parent_id);
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    question.answer,
    question.validated,
    question.metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    parent_id$1,
    question.created_at,
    question.updated_at,
  );
}

export function set_content(question, content) {
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    content,
    question.answer,
    question.validated,
    question.metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

export function set_metadata(question, metadata) {
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    question.answer,
    question.validated,
    metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

export function start_processing(question) {
  let ai_processing = true;
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    question.answer,
    question.validated,
    question.metadata,
    ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

/**
 * Whether nabu can fill this slot at all. A multiple choice with nothing to
 * pick from cannot be answered, and "nothing to pick from" has two spellings:
 * `None` (the slot never carried a choice list) and `Some([])` (it carries an
 * empty one).
 *
 * This is the single source of truth for that rule: `ask_question_tasks`
 * builds nabu's task list on it, and `stop_processing` skips the slots it
 * rejects. The two must agree — a slot heimdall never asks about never gets a
 * score, and would otherwise pin the question on `ai_processing` until the
 * 30-minute cron.
 */
export function is_answerable(answer) {
  let $ = answer.kind;
  let $1 = answer.choices;
  if ($ instanceof Long) {
    return true;
  } else if ($ instanceof YesNo) {
    return true;
  } else if ($1 instanceof Some) {
    let $2 = $1[0];
    if ($2 instanceof $Empty) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

/**
 * Clears `ai_processing` once every slot nabu was asked about carries a
 * score. Slots `is_answerable` rejects are ignored: no task went out for
 * them, so no response will ever come back to score them.
 */
export function stop_processing(question) {
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    question.answer,
    question.validated,
    question.metadata,
    (() => {
      let _pipe = question.answer;
      let _pipe$1 = $dict.values(_pipe);
      return $list.any(
        _pipe$1,
        (answer) => {
          return is_answerable(answer) && $option.is_none(answer.score);
        },
      );
    })(),
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

export function get_textual_answer(question) {
  let _pipe = get_first_answer_of_kind(question, new Long());
  return $option.from_result(_pipe);
}

function compare_position(a, b) {
  if (a instanceof Some) {
    if (b instanceof Some) {
      let ax = a[0][0];
      let bx = b[0][0];
      return $int.compare(ax, bx);
    } else {
      return new $order.Gt();
    }
  } else if (b instanceof Some) {
    return new $order.Lt();
  } else {
    return new $order.Eq();
  }
}

/**
 * Every main (unstyled) textual answer of a question — SL-9's whole point:
 * one per complementary answer column, instead of `get_textual_answer`'s
 * single pick. Sorted by position so callers building an ordered list
 * (docx paragraphs, CSV columns) render in the same order every time.
 *
 * Empty for a question with no `Long` answer at all, exactly like
 * `get_textual_answer` returning `None` in that case.
 */
export function get_textual_answers(question) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.filter(
    _pipe$1,
    (v) => {
      return (v.kind instanceof Long) && $option.is_none(v.answer_style_id);
    },
  );
  return $list.sort(
    _pipe$2,
    (a, b) => { return compare_position(a.position, b.position); },
  );
}

/**
 * Every `Long` answer of `new_question` that is either absent from
 * `old_question` (a brand new answer) or whose value differs from its
 * counterpart there (an edit) — diffed by the answer's own id, so a
 * question holding several `Long` answers reports each of them
 * independently instead of collapsing to "the first one".
 */
export function diff_long_answers(new_question, old_question) {
  let _pipe = new_question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.filter(_pipe$1, (a) => { return a.kind instanceof Long; });
  return $list.filter_map(
    _pipe$2,
    (new_answer) => {
      let $ = $dict.get(old_question.answer, new_answer.id);
      if ($ instanceof Ok) {
        let old_answer = $[0];
        if (old_answer.value !== new_answer.value) {
          return new Ok(new ChangedLongAnswer(new_answer));
        } else {
          return new Error(undefined);
        }
      } else {
        return new Ok(new NewLongAnswer(new_answer));
      }
    },
  );
}

export function new_long() {
  let id = $uuid.new$();
  return new Answer(
    id,
    "",
    new Long(),
    new None(),
    new None(),
    new None(),
    new None(),
    toList([]),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
}

/**
 * Gives the question one empty `Long` slot per `(position, style)` it does
 * not already have one for, so the fan-out has an `answer_id` to send a task
 * under and the answer coming back has somewhere to land. Positions are
 * taken from the question's own unstyled `Long` answers — one per
 * complementary answer column (SL-9) — so a question with two textual
 * columns and two styles gets 2×2 = 4 slots, never 2.
 *
 * Idempotent, and that is the point: a `(position, style)` already holding a
 * slot is left exactly as it is, existing answers included. This is what
 * keeps **one slot per (position, style)** true — `list_textual_answers`
 * reads "the latest answer of each style" off the slots, and `Answer` has no
 * timestamp to break a tie with.
 *
 * `styles` is the list of *enabled* styles: passing an empty list is a no-op,
 * which is how an org that configured nothing keeps generating exactly one
 * answer per column.
 */
export function ensure_style_slots(question, styles) {
  let _block;
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.filter(
    _pipe$1,
    (a) => {
      return (a.kind instanceof Long) && $option.is_none(a.answer_style_id);
    },
  );
  let _pipe$3 = $list.map(_pipe$2, (a) => { return a.position; });
  _block = $list.unique(_pipe$3);
  let main_positions = _block;
  return update_answers(
    question,
    (answers) => {
      return $list.fold(
        main_positions,
        answers,
        (answers, position) => {
          return $list.fold(
            styles,
            answers,
            (answers, style_id) => {
              let _block$1;
              let _pipe$4 = answers;
              let _pipe$5 = $dict.values(_pipe$4);
              _block$1 = $list.any(
                _pipe$5,
                (a) => {
                  return ((a.kind instanceof Long) && (isEqual(
                    a.answer_style_id,
                    new Some(style_id)
                  ))) && (isEqual(a.position, position));
                },
              );
              let has_slot = _block$1;
              return $bool.guard(
                has_slot,
                answers,
                () => {
                  let id = $uuid.new$();
                  let _block$2;
                  let _record = new_long();
                  _block$2 = new Answer(
                    id,
                    _record.value,
                    _record.kind,
                    _record.choices,
                    position,
                    _record.score,
                    _record.explanation,
                    _record.context_used,
                    _record.init_value,
                    new Some(style_id),
                    _record.header,
                    _record.instruction,
                    _record.column_role,
                  );
                  let slot = _block$2;
                  return $dict.insert(answers, id, slot);
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * The variant a question carries for one answer style, at one answer
 * column. `None` covers both "this org does not use that style" and
 * "generation has not come back yet".
 */
export function get_textual_answer_for_style(question, position, style_id) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.find(
    _pipe$1,
    (v) => {
      return ((v.kind instanceof Long) && (isEqual(
        v.answer_style_id,
        new Some(style_id)
      ))) && (isEqual(v.position, position));
    },
  );
  return $option.from_result(_pipe$2);
}

/**
 * Every textual answer of one answer column: the main one first, then the
 * styled variants. `question.answer` holds the current value of each slot,
 * so this is the latest answer of each style — as long as a style owns a
 * single slot per position, which minting one `answer_id` per
 * `(position, style)` is what guarantees.
 *
 * The order only has to be stable: the questionnaire shows the main answer
 * and lets the reader unfold the rest to compare, so how variants are ranked
 * among themselves is the view's call.
 */
export function list_textual_answers(question, position) {
  let _block;
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.filter(
    _pipe$1,
    (v) => {
      return (v.kind instanceof Long) && (isEqual(v.position, position));
    },
  );
  _block = $list.partition(
    _pipe$2,
    (v) => { return $option.is_none(v.answer_style_id); },
  );
  let $ = _block;
  let main = $[0];
  let variants = $[1];
  let _pipe$3 = variants;
  let _pipe$4 = $list.sort(
    _pipe$3,
    (a, b) => {
      return $string.compare(
        $option.unwrap(a.answer_style_id, ""),
        $option.unwrap(b.answer_style_id, ""),
      );
    },
  );
  return ((_capture) => { return $list.append(main, _capture); })(_pipe$4);
}

export function update_answer(question, answer_id, value) {
  let $ = $dict.get(question.answer, answer_id);
  if ($ instanceof Ok) {
    let answer = $[0];
    let $1 = answer.kind;
    if ($1 instanceof Long) {
      return update_textual_answer(
        question,
        answer_id,
        value,
        answer.score,
        answer.explanation,
        answer.context_used,
        answer.answer_style_id,
      );
    } else if ($1 instanceof YesNo) {
      return update_yes_no_answer(
        question,
        answer_id,
        value,
        answer.score,
        answer.explanation,
        answer.context_used,
      );
    } else {
      return update_multiple_choice_answer(
        question,
        answer_id,
        value,
        answer.score,
        answer.explanation,
        answer.context_used,
      );
    }
  } else {
    return question;
  }
}

export function update_table_question_content(question, questions_answers) {
  let $ = question.metadata;
  let metadata;
  if ($ instanceof SheetQuestion) {
    metadata = $;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/proposal_element/question",
      1192,
      "update_table_question_content",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 39349,
        end: 39409,
        pattern_start: 39360,
        pattern_end: 39389
      }
    )
  }
  let $1 = metadata.position;
  if ($1 instanceof Some) {
    let position = $1[0];
    let $2 = $dict.get(questions_answers, position);
    if ($2 instanceof Ok) {
      let content = $2[0];
      return set_content(question, content);
    } else {
      return question;
    }
  } else {
    return question;
  }
}

function is_yes_no(answer, yesno_to_string) {
  let answer$1 = $string.lowercase(answer);
  return $list.any(
    $language.all,
    (language) => {
      let yesno_to_string$1 = $string.lowercase(yesno_to_string(language));
      return $string.contains(answer$1, yesno_to_string$1);
    },
  );
}

export function update_table_question_answer(question, questions_answers) {
  let answers = $dict.to_list(question.answer);
  return $dict.fold(
    questions_answers,
    question,
    (question, position, content) => {
      let $ = $list.find(
        answers,
        (a) => { return isEqual(a[1].position, new Some(position)); },
      );
      if ($ instanceof Ok) {
        let $1 = $[0][1].kind;
        if ($1 instanceof Long) {
          let answer = $[0][1];
          return update_textual_answer(
            question,
            answer.id,
            content,
            answer.score,
            answer.explanation,
            answer.context_used,
            answer.answer_style_id,
          );
        } else if ($1 instanceof YesNo) {
          let answer = $[0][1];
          let is_yes = is_yes_no(content, $language.to_yes);
          let is_no = is_yes_no(content, $language.to_no);
          let is_na = is_yes_no(content, $language.to_na);
          let _block;
          if (is_yes) {
            _block = new Ok("YES");
          } else if (is_no) {
            _block = new Ok("NO");
          } else if (is_na) {
            _block = new Ok("NA");
          } else {
            _block = new Error(undefined);
          }
          let content$1 = _block;
          if (content$1 instanceof Ok) {
            let content$2 = content$1[0];
            return update_yes_no_answer(
              question,
              answer.id,
              content$2,
              answer.score,
              answer.explanation,
              answer.context_used,
            );
          } else {
            return question;
          }
        } else {
          let answer = $[0][1];
          return update_multiple_choice_answer(
            question,
            answer.id,
            content,
            answer.score,
            answer.explanation,
            answer.context_used,
          );
        }
      } else {
        return question;
      }
    },
  );
}

export function new_choices(options) {
  let id = $uuid.new$();
  return new Answer(
    id,
    "",
    new MultipleChoice(),
    new Some(options),
    new None(),
    new None(),
    new None(),
    toList([]),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
}

export function compare_kind(a, b) {
  let $ = a.kind;
  let $1 = b.kind;
  if ($ instanceof Long) {
    if ($1 instanceof Long) {
      return new $order.Eq();
    } else if ($1 instanceof YesNo) {
      return new $order.Lt();
    } else {
      return new $order.Lt();
    }
  } else if ($ instanceof YesNo) {
    if ($1 instanceof Long) {
      return new $order.Gt();
    } else if ($1 instanceof YesNo) {
      return new $order.Eq();
    } else {
      return new $order.Lt();
    }
  } else if ($1 instanceof Long) {
    return new $order.Gt();
  } else if ($1 instanceof YesNo) {
    return new $order.Gt();
  } else {
    return new $order.Eq();
  }
}

export function compare_answer(a, b) {
  let ordered_by_kind = compare_kind(a, b);
  return $order.lazy_break_tie(
    ordered_by_kind,
    () => {
      let $ = a.position;
      let $1 = b.position;
      if ($ instanceof Some) {
        if ($1 instanceof Some) {
          let p1 = $[0];
          let p2 = $1[0];
          return $int.compare(p1[1], p2[1]);
        } else {
          return new $order.Lt();
        }
      } else if ($1 instanceof Some) {
        return new $order.Gt();
      } else {
        return new $order.Eq();
      }
    },
  );
}

export function position_to_string(position) {
  let x = position[0];
  let y = position[1];
  let x$1 = $int.to_string(x);
  let y$1 = $int.to_string(y);
  return ((("(" + x$1) + ",") + y$1) + ")";
}

/**
 * Used in `decode.failure` functions.
 */
export function empty() {
  let now = $timestamp.system_time();
  return new Question(
    "",
    "",
    new None(),
    "",
    $dict.new$(),
    false,
    new SheetQuestion(
      new None(),
      new None(),
      toList([]),
      toList([]),
      new None(),
      new None(),
      new None(),
      new None(),
    ),
    false,
    false,
    -1,
    -1,
    new None(),
    now,
    now,
  );
}

export function remove_init_values(question) {
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    $dict.map_values(
      question.answer,
      (_, value) => {
        return new Answer(
          value.id,
          value.value,
          value.kind,
          value.choices,
          value.position,
          new None(),
          new None(),
          toList([]),
          new None(),
          value.answer_style_id,
          value.header,
          value.instruction,
          value.column_role,
        );
      },
    ),
    question.validated,
    question.metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

/**
 * Same as `remove_init_values`, but scoped to specific answer ids — every
 * other answer on the question keeps its current value untouched. Used to
 * retrigger AI generation for only the answer target(s) that actually need
 * it (e.g. a single multiple-choice group whose values changed), leaving
 * sibling answers on the same question alone.
 */
export function remove_init_values_for(question, answer_ids) {
  return new Question(
    question.id,
    question.proposal_id,
    question.owner,
    question.content,
    $dict.map_values(
      question.answer,
      (id, value) => {
        let $ = $list.contains(answer_ids, id);
        if ($) {
          return new Answer(
            value.id,
            value.value,
            value.kind,
            value.choices,
            value.position,
            new None(),
            new None(),
            toList([]),
            new None(),
            value.answer_style_id,
            value.header,
            value.instruction,
            value.column_role,
          );
        } else {
          return value;
        }
      },
    ),
    question.validated,
    question.metadata,
    question.ai_processing,
    question.assign_processing,
    question.qa_order,
    question.doc_id_order,
    question.parent_id,
    question.created_at,
    question.updated_at,
  );
}

export function numbering(question) {
  let $ = question.metadata;
  if ($ instanceof PortalQuestion) {
    return new None();
  } else {
    let numbering$1 = $.numbering;
    return new Some(numbering$1);
  }
}

function to_answer_kind(kind) {
  if (kind instanceof Long) {
    return new $answer.Long();
  } else if (kind instanceof YesNo) {
    return new $answer.YesNo();
  } else {
    return new $answer.MultipleChoice();
  }
}

export function to_answer_v2(question, answer, writing_method, editor) {
  let kind = to_answer_kind(answer.kind);
  let element_id = question.id;
  let choices = answer.choices;
  let position = answer.position;
  let score$1 = answer.score;
  let explanation$1 = answer.explanation;
  let context_used$1 = answer.context_used;
  let version = $answer.answer_type_version;
  let answer_id = answer.id;
  let value = answer.value;
  let writing_method$1 = $option.unwrap(
    writing_method,
    new $answer.HumanWritting(),
  );
  return new $answer.AnswerV2(
    $uuid.new$(),
    element_id,
    answer_id,
    value,
    kind,
    new $answer.Metadata(
      choices,
      position,
      score$1,
      explanation$1,
      context_used$1,
      editor,
      writing_method$1,
      new None(),
      version,
    ),
    -1,
    question.updated_at,
  );
}

export function migrate_to_answer_v2(question, answer) {
  let kind = to_answer_kind(answer.kind);
  let _block;
  let _pipe = question.owner;
  let _pipe$1 = $option.map(_pipe, $user_id.to_string);
  _block = $option.unwrap(_pipe$1, "N/A");
  let editor = _block;
  let element_id = question.id;
  let choices = answer.choices;
  let position = answer.position;
  let score$1 = answer.score;
  let explanation$1 = answer.explanation;
  let context_used$1 = answer.context_used;
  let version = 1;
  let answer_id = answer.id;
  let $ = (() => {
    let _pipe$2 = answer.value;
    let _pipe$3 = $html_parser.clean_html_string(_pipe$2);
    return $string.trim(_pipe$3);
  })();
  let $1 = (() => {
    let _pipe$2 = answer.init_value;
    return $option.map(
      _pipe$2,
      (iv) => {
        let _pipe$3 = iv;
        let _pipe$4 = $html_parser.clean_html_string(_pipe$3);
        return $string.trim(_pipe$4);
      },
    );
  })();
  if ($1 instanceof Some) {
    let value = $;
    let initial = $1[0];
    let $2 = $levenshtein.levenshtein(initial, value);
    let d = $2;
    if (d > 10) {
      return toList([
        new $answer.AnswerV2(
          $uuid.new$(),
          element_id,
          answer_id,
          initial,
          kind,
          new $answer.Metadata(
            choices,
            position,
            score$1,
            explanation$1,
            context_used$1,
            editor,
            new $answer.AiFirstGeneration(),
            new None(),
            version,
          ),
          1,
          question.created_at,
        ),
        new $answer.AnswerV2(
          $uuid.new$(),
          element_id,
          answer_id,
          value,
          kind,
          new $answer.Metadata(
            choices,
            position,
            score$1,
            explanation$1,
            context_used$1,
            editor,
            new $answer.HumanWritting(),
            new None(),
            version,
          ),
          2,
          question.updated_at,
        ),
      ]);
    } else {
      return toList([
        new $answer.AnswerV2(
          $uuid.new$(),
          element_id,
          answer_id,
          value,
          kind,
          new $answer.Metadata(
            choices,
            position,
            score$1,
            explanation$1,
            context_used$1,
            editor,
            new $answer.AiFirstGeneration(),
            new None(),
            version,
          ),
          1,
          question.created_at,
        ),
      ]);
    }
  } else {
    let value = $;
    return toList([
      new $answer.AnswerV2(
        $uuid.new$(),
        element_id,
        answer_id,
        value,
        kind,
        new $answer.Metadata(
          choices,
          position,
          score$1,
          explanation$1,
          context_used$1,
          editor,
          new $answer.HumanWritting(),
          new None(),
          version,
        ),
        1,
        question.updated_at,
      ),
    ]);
  }
}

/**
 * Every distinct multiple-choice label this question offers, across all of
 * its answers. Deduplicated: a question commonly repeats the same scale on
 * several answers, and a label is translated once for all of them (Pylon
 * #1182, §22) — so asking per answer would emit the same request several
 * times over.
 */
export function distinct_choice_labels(question) {
  let _pipe = question.answer;
  let _pipe$1 = $dict.values(_pipe);
  let _pipe$2 = $list.flat_map(
    _pipe$1,
    (answer) => {
      let $ = answer.kind;
      let $1 = answer.choices;
      if ($1 instanceof $option.Some && $ instanceof MultipleChoice) {
        let choices = $1[0];
        return choices;
      } else {
        return toList([]);
      }
    },
  );
  return $list.unique(_pipe$2);
}

/**
 * Every `translation.target_id` this question can have a row under: its own
 * id (the `pq` question translation), each answer's id (`pa`/`ex`, keyed by
 * answer since T2), and a digest per distinct multiple-choice label (`ch`,
 * §22). Readers pass this to `select_by_target_ids` — miss one and the
 * translation exists in the database but never reaches the page.
 *
 * ⚠️ Erlang only, because of `choice_target_id`. Called from heimdall's
 * fetch paths; the browser resolves choices by label instead and never
 * needs this.
 */
export function translation_target_ids(question) {
  let answers = $dict.values(question.answer);
  let _block;
  let _pipe = distinct_choice_labels(question);
  _block = $list.map(_pipe, $translate.choice_target_id);
  let choice_ids = _block;
  let _pipe$1 = listPrepend(
    question.id,
    $list.map(answers, (a) => { return a.id; }),
  );
  let _pipe$2 = $list.append(_pipe$1, choice_ids);
  return $list.unique(_pipe$2);
}
